import type { FC } from 'react';
import { createUseStyles, useTheme } from 'react-jss';

import type { LcpnTheme } from '../../styles/theme';

interface CodeBadgeProps {
  code: string;
  backgroundColor?: string;
  textColor?: string;
  fontSize?: string;
  className?: string;
}

const useStyles = createUseStyles((theme: LcpnTheme) => ({
  badge: {
    padding: theme.spacing(1, 2),
    borderRadius: 4,
    fontWeight: 700,
    whiteSpace: 'nowrap',
    display: 'inline-block',
    verticalAlign: 'middle',
    fontSize: theme.fontSizes.p3,
    textDecoration: 'none !important',
    lineHeight: 1.1,
  },
}));

export const CodeBadge: FC<CodeBadgeProps> = ({
  code,
  backgroundColor,
  textColor,
  fontSize,
  className,
}) => {
  const classes = useStyles();
  const theme = useTheme<LcpnTheme>();

  return (
    <span
      className={`${classes.badge} ${className || ''}`}
      style={{
        backgroundColor: backgroundColor || theme.colors['blue-100'],
        color: textColor || theme.colors.white,
        ...(fontSize && { fontSize }),
      }}
    >
      {code}
    </span>
  );
};
